<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-truck-moving"></i></span>{{ 'ReceiptFormHeaderDetails.ReceiptHeaderDetails' | translate }} ({{warehousingHeader?.whNo}}) </h1>
  <p-card>
      <form class="detail-form">
        <div class="field grid">
          <div class="p-fluid formgrid grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReceiptNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.whNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ImportDeclarationNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.importDeclarationNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReceiptStatus' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.whStatus | optionsMapping:whDocStatusOptions  | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Forwarder' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.shipper | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.PayeeType' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.billObjectType | optionsMapping:billObjectTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Payee' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.billObject | optionsMapping:billObjectOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Supplier' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.vendorCustomer | optionsMapping:vendorCustomerOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DeliveryType' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.deliveryType | optionsMapping:deliveryTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Company' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.orgId | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.BillCompany' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.billCorp | optionsMapping:orgIdOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.OriginCountry' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.fromCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.OriginCity' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.fromCity | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.OriginArea' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.fromArea | optionsMapping:areaOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DestinationCountry' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.toCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DestinationCity' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.toCity | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DestinationArea' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.toArea | optionsMapping:areaOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceivingRegistration.MainTable.CourierDeliveryCondition' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.expressTerm | optionsMapping:expressTermOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DeclarationType' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.docType | optionsMapping:docTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TradeTerm' | translate }}</label>
              <div class="col-7 column-value">
                {{ warehousingHeader?.shipTerm | optionsMapping:shipTermOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReceivingTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.whDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.EstimateArrivalDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.expectedDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.HAWB' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.hawbNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.NumPallets' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.palletCnt | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalCartonCnt' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.totalCartonCnt | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalChargeableWeight' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.totalChargeableWeight | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalGrossWeight' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.totalGrossWeight | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalVolumeWeight' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.totalVolumeWeight | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.NumCartonsReceived' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.rfCaseCnt | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.TotalQty' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.totalQty | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ActualQty' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.cartonCnt | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CalculationUnit' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.uom | optionsMapping:uomOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CalculateQty' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.uomQty | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CustomBondedNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.bondedNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.LooseCargoNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.bulkCargoNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.LooseCargoNumLocation' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.bulkCargoNoLocation | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Brand' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.brand | optionsMapping:brandOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ReasonNonReceiving' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.shippingRemark | optionsMapping:shippingRemarkOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DropShipment' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.isDropShipment | optionsMapping:yesNoOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.GenerateExpenses' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.isGenerateFee | optionsMapping:yesNoOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.WarehouseAddress' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.addressCode | optionsMapping:addressCodeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.PickUpAddress' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.deliveryAddress | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.IsUrgent' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.urgentFlag | optionsMapping:urgentFlagOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.FlightNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.flightNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.FlightDate' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.flightDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DeliveryMode' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.shippingMethod | optionsMapping:shippingMethodOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.MAWB' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.mawbNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.IdentificaitonNum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.docNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DocumentSubType' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.deliverySubType | optionsMapping:deliverySubTypeOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.DONum' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.doNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ExpensesDistribution' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.splitDept | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.Creator' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CreationTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.UpdateBy' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.EditTime' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.RFQSetting' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.quotationKey | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.EmployCode' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.employCode | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'WarehousingAbnormal.Form.IsAbnormalNotify' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.isAbnormalNotify | optionsMapping:yesNoOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div *ngIf="warehousingHeader?.feiliksNotifyFlag" class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.FeiliksNotifyFlag' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.feiliksNotifyFlag | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationForwarder' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationForwarder | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.CrossBoundryForwarder' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.crossBoundryForwarder | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationFromCountry' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationFromCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationFromCity' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationFromCity | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationFromArea' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationFromArea | optionsMapping:areaOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationToCountry' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationToCountry | optionsMapping:countryOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationToCity' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationToCity | optionsMapping:cityOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">{{ 'ReceiptFormHeaderDetails.ConsolidationToArea' | translate }}</label>
              <div class="col-8 column-value">
                {{ warehousingHeader?.consolidationToArea | optionsMapping:areaOptions | replaceNullWith:'-' }}
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col">
              <laas-permission-button *ngIf="isShowEditBtn" label="{{ 'Common.Button.Edit' | translate }}" (onClick)="goToEdit($event)" [class]="'mr-2'"></laas-permission-button>
              <laas-permission-button *ngIf="isShowEditRelatedBillBtn" permissionCode="EditWarehousingRelatedBilling" label="{{ 'ReceiptFormHeaderDetails.Button.EditRelatedBillBtn' | translate }}" (onClick)="showEditRelatedBillDialog(true)" [class]="'mr-2'"></laas-permission-button>
              <laas-permission-button *ngIf="isShowCancelBtn" permissionCode="CancelWarehousing" label="{{ 'Common.Button.Cancel' | translate }}" (onClick)="cancelConfirm($event)" [class]="'p-button-secondary'"></laas-permission-button>
            </div>
          </div>
        </div>
      </form>
  </p-card>

  <ng-container *ngIf="isShowEditRelatedBill">
    <laas-warehousing-edit-related-bill
      [(visible)]="isShowEditRelatedBill"
      [warehousingHeader]="warehousingHeader"
      (visibleChange)="showEditRelatedBillDialog($event)">
    </laas-warehousing-edit-related-bill>
  </ng-container>
</div>
